// extracted by mini-css-extract-plugin
export default {"wrapper":"pp","form":"qp","option":"rp","radio":"sp","success":"tp","contest":"up"};